/// Auto-generated. Modifications will be overwritten.
/// Generated from core/document-schemas/BarcodeDocumentModel.yaml
export const BoardingPassDocumentType = 'BoardingPass';
export const BoardingPassLegDocumentType = 'Leg';
export const SwissQRDocumentType = 'SwissQR';
export const DEMedicalPlanDocumentType = 'DEMedicalPlan';
export const DEMedicalPlanPatientDocumentType = 'Patient';
export const DEMedicalPlanDoctorDocumentType = 'Doctor';
export const DEMedicalPlanSubheadingDocumentType = 'Subheading';
export const DEMedicalPlanSubheadingMedicineDocumentType = 'Medicine';
export const DEMedicalPlanSubheadingMedicineSubstanceDocumentType = 'Substance';
export const DEMedicalPlanSubheadingPrescriptionDocumentType = 'Prescription';
export const IDCardPDF417DocumentType = 'IDCardPDF417';
export const GS1DocumentType = 'GS1';
export const GS1ElementDocumentType = 'Element';
export const GS1ElementValidationErrorDocumentType = 'ValidationError';
export const SEPADocumentType = 'SEPA';
export const MedicalCertificateDocumentType = 'MedicalCertificate';
export const VCardDocumentType = 'VCard';
export const VCardEntryDocumentType = 'Entry';
export const VCardVersionDocumentType = 'Version';
export const VCardSourceDocumentType = 'Source';
export const VCardKindDocumentType = 'Kind';
export const VCardXMLDocumentType = 'XML';
export const VCardNameDocumentType = 'Name';
export const VCardFormattedNameDocumentType = 'FormattedName';
export const VCardNicknameDocumentType = 'Nickname';
export const VCardBirthdayDocumentType = 'Birthday';
export const VCardAnniversaryDocumentType = 'Anniversary';
export const VCardGenderDocumentType = 'Gender';
export const VCardDeliveryAddressDocumentType = 'DeliveryAddress';
export const VCardLabelDocumentType = 'Label';
export const VCardPhotoDocumentType = 'Photo';
export const VCardTelephoneNumberDocumentType = 'TelephoneNumber';
export const VCardEmailDocumentType = 'Email';
export const VCardIMPPDocumentType = 'IMPP';
export const VCardLanguagesDocumentType = 'Languages';
export const VCardTimeZoneDocumentType = 'TimeZone';
export const VCardGeoLocationDocumentType = 'GeoLocation';
export const VCardTitleDocumentType = 'Title';
export const VCardRoleDocumentType = 'Role';
export const VCardLogoDocumentType = 'Logo';
export const VCardAgentDocumentType = 'Agent';
export const VCardOrganisationDocumentType = 'Organisation';
export const VCardMemberDocumentType = 'Member';
export const VCardRelatedDocumentType = 'Related';
export const VCardCategoriesDocumentType = 'Categories';
export const VCardNoteDocumentType = 'Note';
export const VCardProductIdDocumentType = 'ProductId';
export const VCardRevisionDocumentType = 'Revision';
export const VCardSoundDocumentType = 'Sound';
export const VCardUIDDocumentType = 'UID';
export const VCardClientPIDMapDocumentType = 'ClientPIDMap';
export const VCardURLDocumentType = 'URL';
export const VCardPublicKeyDocumentType = 'PublicKey';
export const VCardBusyTimeURLDocumentType = 'BusyTimeURL';
export const VCardCalendarURIForRequestsDocumentType = 'CalendarURIForRequests';
export const VCardCalendarURIDocumentType = 'CalendarURI';
export const VCardSortStringDocumentType = 'SortString';
export const VCardClassificationDocumentType = 'Classification';
export const VCardCustomDocumentType = 'Custom';
export const AAMVADocumentType = 'AAMVA';
export const AAMVATitleDataDocumentType = 'TitleData';
export const AAMVARegistrationDataDocumentType = 'RegistrationData';
export const AAMVAMotorCarrierDataDocumentType = 'MotorCarrierData';
export const AAMVARegistrantAndVehicleDataDocumentType = 'RegistrantAndVehicleData';
export const AAMVAVehicleOwnerDataDocumentType = 'VehicleOwnerData';
export const AAMVAVehicleDataDocumentType = 'VehicleData';
export const AAMVAVehicleSafetyInspectionDataDocumentType = 'VehicleSafetyInspectionData';
export const AAMVADLIDDocumentType = 'DLID';
export const AAMVADriverLicenseDocumentType = 'DriverLicense';
export const AAMVAIDCardDocumentType = 'IDCard';
export const AAMVAEnhancedDriverLicenseDocumentType = 'EnhancedDriverLicense';
export const AAMVARawDocumentDocumentType = 'RawDocument';
export const HIBCDocumentType = 'HIBC';
/** Boarding Pass */
export class BoardingPass {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return BoardingPassDocumentType;
    }
    /** Electronic Ticket */
    get electronicTicketIndicator() {
        return this.document.fields.find((f) => f.type.name === 'ElectronicTicketIndicator');
    }
    /** Format Code. */
    get formatCode() {
        return this.document.fields.find((f) => f.type.name === 'FormatCode');
    }
    /** Number of encoded legs. */
    get numberOfLegs() {
        return this.document.fields.find((f) => f.type.name === 'NumberOfLegs');
    }
    /** Passenger Name */
    get passengerName() {
        return this.document.fields.find((f) => f.type.name === 'PassengerName');
    }
    /** Security Data */
    get securityData() {
        return this.document.fields.find((f) => f.type.name === 'SecurityData');
    }
    /** Security Data Type */
    get securityDataType() {
        return this.document.fields.find((f) => f.type.name === 'SecurityDataType');
    }
    /** An array of all children of type "Leg". */
    get legs() {
        return this.document.children
            .filter((c) => c.type.name === 'Leg')
            .map((c) => new BoardingPass.Leg(c));
    }
}
(function (BoardingPass) {
    /** Leg of the journey */
    class Leg {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return BoardingPassLegDocumentType;
        }
        /** Airline Designator Of Boarding Pass Issuer */
        get airlineDesignatorOfBoardingPassIssuer() {
            return this.document.fields.find((f) => f.type.name === 'AirlineDesignatorOfBoardingPassIssuer');
        }
        /** Airline Numeric Code */
        get airlineNumericCode() {
            return this.document.fields.find((f) => f.type.name === 'AirlineNumericCode');
        }
        /** Baggage Tag License Plate Numbers */
        get baggageTagLicensePlateNumbers() {
            return this.document.fields.find((f) => f.type.name === 'BaggageTagLicensePlateNumbers');
        }
        /** Check In Sequence Number */
        get checkInSequenceNumber() {
            return this.document.fields.find((f) => f.type.name === 'CheckInSequenceNumber');
        }
        /** Compartment Code */
        get compartmentCode() {
            return this.document.fields.find((f) => f.type.name === 'CompartmentCode');
        }
        /** Date Of Boarding Pass Issuance Julian */
        get dateOfBoardingPassIssuanceJulian() {
            return this.document.fields.find((f) => f.type.name === 'DateOfBoardingPassIssuanceJulian');
        }
        /** Date Of Flight Julian */
        get dateOfFlightJulian() {
            return this.document.fields.find((f) => f.type.name === 'DateOfFlightJulian');
        }
        /** Departure Airport Code */
        get departureAirportCode() {
            return this.document.fields.find((f) => f.type.name === 'DepartureAirportCode');
        }
        /** Destination Airport Code */
        get destinationAirportCode() {
            return this.document.fields.find((f) => f.type.name === 'DestinationAirportCode');
        }
        /** Document Form Serial Number */
        get documentFormSerialNumber() {
            return this.document.fields.find((f) => f.type.name === 'DocumentFormSerialNumber');
        }
        /** Document Type */
        get documentType() {
            return this.document.fields.find((f) => f.type.name === 'DocumentType');
        }
        /** Fast Track */
        get fastTrack() {
            return this.document.fields.find((f) => f.type.name === 'FastTrack');
        }
        /** First Non Consecutive Baggage Tag License Plate Number */
        get firstNonConsecutiveBaggageTagLicensePlateNumber() {
            return this.document.fields.find((f) => f.type.name === 'FirstNonConsecutiveBaggageTagLicensePlateNumber');
        }
        /** Flight Number */
        get flightNumber() {
            return this.document.fields.find((f) => f.type.name === 'FlightNumber');
        }
        /** For Individual Airline Use */
        get forIndividualAirlineUse() {
            return this.document.fields.find((f) => f.type.name === 'ForIndividualAirlineUse');
        }
        /** Free Baggage Allowance */
        get freeBaggageAllowance() {
            return this.document.fields.find((f) => f.type.name === 'FreeBaggageAllowance');
        }
        /** Frequent Flyer Airline Designator */
        get frequentFlyerAirlineDesignator() {
            return this.document.fields.find((f) => f.type.name === 'FrequentFlyerAirlineDesignator');
        }
        /** Frequent Flyer Number */
        get frequentFlyerNumber() {
            return this.document.fields.find((f) => f.type.name === 'FrequentFlyerNumber');
        }
        /** IDAD Indicator */
        get idadIndicator() {
            return this.document.fields.find((f) => f.type.name === 'IDADIndicator');
        }
        /** International Documentation Verification */
        get internationalDocumentationVerification() {
            return this.document.fields.find((f) => f.type.name === 'InternationalDocumentationVerification');
        }
        /** Marketing Carrier Designator */
        get marketingCarrierDesignator() {
            return this.document.fields.find((f) => f.type.name === 'MarketingCarrierDesignator');
        }
        /** Operating Carrier Designator */
        get operatingCarrierDesignator() {
            return this.document.fields.find((f) => f.type.name === 'OperatingCarrierDesignator');
        }
        /** Operating Carrier PNR Code */
        get operatingCarrierPNRCode() {
            return this.document.fields.find((f) => f.type.name === 'OperatingCarrierPNRCode');
        }
        /** Passenger Description */
        get passengerDescription() {
            return this.document.fields.find((f) => f.type.name === 'PassengerDescription');
        }
        /** Passenger Status */
        get passengerStatus() {
            return this.document.fields.find((f) => f.type.name === 'PassengerStatus');
        }
        /** Seat Number */
        get seatNumber() {
            return this.document.fields.find((f) => f.type.name === 'SeatNumber');
        }
        /** Second Non Consecutive Baggage Tag License Plate Number */
        get secondNonConsecutiveBaggageTagLicensePlateNumber() {
            return this.document.fields.find((f) => f.type.name === 'SecondNonConsecutiveBaggageTagLicensePlateNumber');
        }
        /** Selectee Indicator */
        get selecteeIndicator() {
            return this.document.fields.find((f) => f.type.name === 'SelecteeIndicator');
        }
        /** Source Of Boarding Pass Issuance */
        get sourceOfBoardingPassIssuance() {
            return this.document.fields.find((f) => f.type.name === 'SourceOfBoardingPassIssuance');
        }
        /** Source Of Check In */
        get sourceOfCheckIn() {
            return this.document.fields.find((f) => f.type.name === 'SourceOfCheckIn');
        }
        /** VersionNumber */
        get versionNumber() {
            return this.document.fields.find((f) => f.type.name === 'VersionNumber');
        }
    }
    BoardingPass.Leg = Leg;
})(BoardingPass || (BoardingPass = {}));
/** SwissQR */
export class SwissQR {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return SwissQRDocumentType;
    }
    /** Additional Billing Information */
    get additionalBillingInformation() {
        return this.document.fields.find((f) => f.type.name === 'AdditionalBillingInformation');
    }
    /** Additional Info Trailer */
    get additionalInfoTrailer() {
        return this.document.fields.find((f) => f.type.name === 'AdditionalInfoTrailer');
    }
    /** Additional Info Unstructured */
    get additionalInfoUnstructured() {
        return this.document.fields.find((f) => f.type.name === 'AdditionalInfoUnstructured');
    }
    /** Alternative Procedure Parameter */
    get alternativeProcedureParameter() {
        return this.document.fields.find((f) => f.type.name === 'AlternativeProcedureParameter');
    }
    /** Amount */
    get amount() {
        return this.document.fields.find((f) => f.type.name === 'Amount');
    }
    /** Currency */
    get currency() {
        return this.document.fields.find((f) => f.type.name === 'Currency');
    }
    /** Debtor Address Type */
    get debtorAddressType() {
        return this.document.fields.find((f) => f.type.name === 'DebtorAddressType');
    }
    /** Debtor Building Or Address Line 2 */
    get debtorBuildingOrAddressLine2() {
        return this.document.fields.find((f) => f.type.name === 'DebtorBuildingOrAddressLine2');
    }
    /** Debtor Country */
    get debtorCountry() {
        return this.document.fields.find((f) => f.type.name === 'DebtorCountry');
    }
    /** Debtor Name */
    get debtorName() {
        return this.document.fields.find((f) => f.type.name === 'DebtorName');
    }
    /** Debtor Place */
    get debtorPlace() {
        return this.document.fields.find((f) => f.type.name === 'DebtorPlace');
    }
    /** Debtor Postal Code */
    get debtorPostalCode() {
        return this.document.fields.find((f) => f.type.name === 'DebtorPostalCode');
    }
    /** Debtor Street Or Address Line 1 */
    get debtorStreetOrAddressLine1() {
        return this.document.fields.find((f) => f.type.name === 'DebtorStreetOrAddressLine1');
    }
    /** Due Date */
    get dueDate() {
        return this.document.fields.find((f) => f.type.name === 'DueDate');
    }
    /** Encoding */
    get encoding() {
        return this.document.fields.find((f) => f.type.name === 'Encoding');
    }
    /** Final Payee Address Type */
    get finalPayeeAddressType() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeAddressType');
    }
    /** Final Payee Building Or Address Line 2 */
    get finalPayeeBuildingOrAddressLine2() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeBuildingOrAddressLine2');
    }
    /** Final Payee Country */
    get finalPayeeCountry() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeCountry');
    }
    /** Final Payee Name */
    get finalPayeeName() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeName');
    }
    /** Final Payee Place */
    get finalPayeePlace() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeePlace');
    }
    /** Final Payee Postal Code */
    get finalPayeePostalCode() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeePostalCode');
    }
    /** Final Payee Street Or Address Line 1 */
    get finalPayeeStreetOrAddressLine1() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeStreetOrAddressLine1');
    }
    /** IBAN */
    get iban() {
        return this.document.fields.find((f) => f.type.name === 'IBAN');
    }
    /** Major Version */
    get majorVersion() {
        return this.document.fields.find((f) => f.type.name === 'MajorVersion');
    }
    /** Payee Address Type */
    get payeeAddressType() {
        return this.document.fields.find((f) => f.type.name === 'PayeeAddressType');
    }
    /** Payee Building Or Address Line 2 */
    get payeeBuildingOrAddressLine2() {
        return this.document.fields.find((f) => f.type.name === 'PayeeBuildingOrAddressLine2');
    }
    /** Payee Country */
    get payeeCountry() {
        return this.document.fields.find((f) => f.type.name === 'PayeeCountry');
    }
    /** Payee Name */
    get payeeName() {
        return this.document.fields.find((f) => f.type.name === 'PayeeName');
    }
    /** Payee Place */
    get payeePlace() {
        return this.document.fields.find((f) => f.type.name === 'PayeePlace');
    }
    /** Payee Postal Code */
    get payeePostalCode() {
        return this.document.fields.find((f) => f.type.name === 'PayeePostalCode');
    }
    /** Payee Street Or Address Line 1 */
    get payeeStreetOrAddressLine1() {
        return this.document.fields.find((f) => f.type.name === 'PayeeStreetOrAddressLine1');
    }
    /** Payment Reference */
    get paymentReference() {
        return this.document.fields.find((f) => f.type.name === 'PaymentReference');
    }
    /** Payment Reference Type */
    get paymentReferenceType() {
        return this.document.fields.find((f) => f.type.name === 'PaymentReferenceType');
    }
}
/** Medical Plan */
export class DEMedicalPlan {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DEMedicalPlanDocumentType;
    }
    /** Current Page */
    get currentPage() {
        return this.document.fields.find((f) => f.type.name === 'CurrentPage');
    }
    /** Document Version Number */
    get documentVersionNumber() {
        return this.document.fields.find((f) => f.type.name === 'DocumentVersionNumber');
    }
    /** GUID */
    get guid() {
        return this.document.fields.find((f) => f.type.name === 'GUID');
    }
    /** Language Country Code */
    get languageCountryCode() {
        return this.document.fields.find((f) => f.type.name === 'LanguageCountryCode');
    }
    /** Patch Version Number */
    get patchVersionNumber() {
        return this.document.fields.find((f) => f.type.name === 'PatchVersionNumber');
    }
    /** Total Number Of Pages */
    get totalNumberOfPages() {
        return this.document.fields.find((f) => f.type.name === 'TotalNumberOfPages');
    }
    /** The child document of type "Patient". */
    get patient() {
        const child = this.document.children.find((c) => c.type.name === 'Patient');
        return new DEMedicalPlan.Patient(child);
    }
    /** The child document of type "Doctor". */
    get doctor() {
        const child = this.document.children.find((c) => c.type.name === 'Doctor');
        return new DEMedicalPlan.Doctor(child);
    }
    /** An array of all children of type "Subheading". */
    get subheadings() {
        return this.document.children
            .filter((c) => c.type.name === 'Subheading')
            .map((c) => new DEMedicalPlan.Subheading(c));
    }
}
(function (DEMedicalPlan) {
    /** Patient */
    class Patient {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return DEMedicalPlanPatientDocumentType;
        }
        /** Allergies And Intolerances */
        get allergiesAndIntolerances() {
            return this.document.fields.find((f) => f.type.name === 'AllergiesAndIntolerances');
        }
        /** Birth Date */
        get birthDate() {
            return this.document.fields.find((f) => f.type.name === 'BirthDate');
        }
        /** Breast Feeding */
        get breastFeeding() {
            return this.document.fields.find((f) => f.type.name === 'BreastFeeding');
        }
        /** Creatinine Value */
        get creatinineValue() {
            return this.document.fields.find((f) => f.type.name === 'CreatinineValue');
        }
        /** First Name */
        get firstName() {
            return this.document.fields.find((f) => f.type.name === 'FirstName');
        }
        /** Gender */
        get gender() {
            return this.document.fields.find((f) => f.type.name === 'Gender');
        }
        /** Height */
        get height() {
            return this.document.fields.find((f) => f.type.name === 'Height');
        }
        /** Last Name */
        get lastName() {
            return this.document.fields.find((f) => f.type.name === 'LastName');
        }
        /** Patient Free Text */
        get patientFreeText() {
            return this.document.fields.find((f) => f.type.name === 'PatientFreeText');
        }
        /** Patient ID */
        get patientID() {
            return this.document.fields.find((f) => f.type.name === 'PatientID');
        }
        /** Pre Name */
        get preName() {
            return this.document.fields.find((f) => f.type.name === 'PreName');
        }
        /** Pregnant */
        get pregnant() {
            return this.document.fields.find((f) => f.type.name === 'Pregnant');
        }
        /** Name Suffix */
        get suffix() {
            return this.document.fields.find((f) => f.type.name === 'Suffix');
        }
        /** Title */
        get title() {
            return this.document.fields.find((f) => f.type.name === 'Title');
        }
        /** Weight */
        get weight() {
            return this.document.fields.find((f) => f.type.name === 'Weight');
        }
    }
    DEMedicalPlan.Patient = Patient;
    /** Doctor */
    class Doctor {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return DEMedicalPlanDoctorDocumentType;
        }
        /** Doctor Number */
        get doctorNumber() {
            return this.document.fields.find((f) => f.type.name === 'DoctorNumber');
        }
        /** Email */
        get email() {
            return this.document.fields.find((f) => f.type.name === 'Email');
        }
        /** Hospital ID */
        get hospitalID() {
            return this.document.fields.find((f) => f.type.name === 'HospitalID');
        }
        /** Issuer Name */
        get issuerName() {
            return this.document.fields.find((f) => f.type.name === 'IssuerName');
        }
        /** Issuing Date And Time */
        get issuingDateAndTime() {
            return this.document.fields.find((f) => f.type.name === 'IssuingDateAndTime');
        }
        /** Pharmacy ID */
        get pharmacyID() {
            return this.document.fields.find((f) => f.type.name === 'PharmacyID');
        }
        /** Place */
        get place() {
            return this.document.fields.find((f) => f.type.name === 'Place');
        }
        /** Postal Code */
        get postalCode() {
            return this.document.fields.find((f) => f.type.name === 'PostalCode');
        }
        /** Street */
        get street() {
            return this.document.fields.find((f) => f.type.name === 'Street');
        }
        /** Telephone Number */
        get telephoneNumber() {
            return this.document.fields.find((f) => f.type.name === 'TelephoneNumber');
        }
    }
    DEMedicalPlan.Doctor = Doctor;
    /** Subheading */
    class Subheading {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return DEMedicalPlanSubheadingDocumentType;
        }
        /** General Note */
        get generalNotes() {
            return this.document.fields.filter((f) => f.type.name === 'GeneralNote');
        }
        /** Key Words */
        get keyWords() {
            return this.document.fields.find((f) => f.type.name === 'KeyWords');
        }
        /** Subheading Free Text */
        get subheadingFreeText() {
            return this.document.fields.find((f) => f.type.name === 'SubheadingFreeText');
        }
        /** An array of all children of type "Medicine". */
        get medicines() {
            return this.document.children
                .filter((c) => c.type.name === 'Medicine')
                .map((c) => new DEMedicalPlan.Subheading.Medicine(c));
        }
        /** An array of all children of type "Prescription". */
        get prescriptions() {
            return this.document.children
                .filter((c) => c.type.name === 'Prescription')
                .map((c) => new DEMedicalPlan.Subheading.Prescription(c));
        }
    }
    DEMedicalPlan.Subheading = Subheading;
    (function (Subheading) {
        /** Medicine */
        class Medicine {
            get document() {
                return this._document;
            }
            constructor(document) {
                if (document.type.name !== this.requiredDocumentType()) {
                    throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
                }
                this._document = document;
            }
            requiredDocumentType() {
                return DEMedicalPlanSubheadingMedicineDocumentType;
            }
            /** Dosage Form */
            get dosageForm() {
                return this.document.fields.find((f) => f.type.name === 'DosageForm');
            }
            /** Dosage Form Free Text */
            get dosageFormFreeText() {
                return this.document.fields.find((f) => f.type.name === 'DosageFormFreeText');
            }
            /** Dosage Free Text */
            get dosageFreeText() {
                return this.document.fields.find((f) => f.type.name === 'DosageFreeText');
            }
            /** Dosing Unit */
            get dosingUnit() {
                return this.document.fields.find((f) => f.type.name === 'DosingUnit');
            }
            /** Dosing Unit Free Text */
            get dosingUnitFreeText() {
                return this.document.fields.find((f) => f.type.name === 'DosingUnitFreeText');
            }
            /** Drug Name */
            get drugName() {
                return this.document.fields.find((f) => f.type.name === 'DrugName');
            }
            /** Evening Intake Dose */
            get evening() {
                return this.document.fields.find((f) => f.type.name === 'Evening');
            }
            /** General Notes */
            get generalNotes() {
                return this.document.fields.find((f) => f.type.name === 'GeneralNotes');
            }
            /** Midday Intake Dose */
            get midday() {
                return this.document.fields.find((f) => f.type.name === 'Midday');
            }
            /** Morning Intake Dose */
            get morning() {
                return this.document.fields.find((f) => f.type.name === 'Morning');
            }
            /** Night Intake Dose */
            get night() {
                return this.document.fields.find((f) => f.type.name === 'Night');
            }
            /** Pharmaceutical Number */
            get pharmaceuticalNumber() {
                return this.document.fields.find((f) => f.type.name === 'PharmaceuticalNumber');
            }
            /** Reason For Treatment */
            get reasonForTreatment() {
                return this.document.fields.find((f) => f.type.name === 'ReasonForTreatment');
            }
            /** Relevant Info */
            get relevantInfo() {
                return this.document.fields.find((f) => f.type.name === 'RelevantInfo');
            }
            /** An array of all children of type "Substance". */
            get substances() {
                return this.document.children
                    .filter((c) => c.type.name === 'Substance')
                    .map((c) => new DEMedicalPlan.Subheading.Medicine.Substance(c));
            }
        }
        Subheading.Medicine = Medicine;
        (function (Medicine) {
            /** Substance */
            class Substance {
                get document() {
                    return this._document;
                }
                constructor(document) {
                    if (document.type.name !== this.requiredDocumentType()) {
                        throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
                    }
                    this._document = document;
                }
                requiredDocumentType() {
                    return DEMedicalPlanSubheadingMedicineSubstanceDocumentType;
                }
                /** Active Substance */
                get activeSubstance() {
                    return this.document.fields.find((f) => f.type.name === 'ActiveSubstance');
                }
                /** Potency */
                get potency() {
                    return this.document.fields.find((f) => f.type.name === 'Potency');
                }
            }
            Medicine.Substance = Substance;
        })(Medicine = Subheading.Medicine || (Subheading.Medicine = {}));
        /** Prescription */
        class Prescription {
            get document() {
                return this._document;
            }
            constructor(document) {
                if (document.type.name !== this.requiredDocumentType()) {
                    throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
                }
                this._document = document;
            }
            requiredDocumentType() {
                return DEMedicalPlanSubheadingPrescriptionDocumentType;
            }
            /** General Information */
            get generalInformation() {
                return this.document.fields.find((f) => f.type.name === 'GeneralInformation');
            }
            /** Prescription Free Text */
            get prescriptionFreeText() {
                return this.document.fields.find((f) => f.type.name === 'PrescriptionFreeText');
            }
        }
        Subheading.Prescription = Prescription;
    })(Subheading = DEMedicalPlan.Subheading || (DEMedicalPlan.Subheading = {}));
})(DEMedicalPlan || (DEMedicalPlan = {}));
/** ID Card */
export class IDCardPDF417 {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return IDCardPDF417DocumentType;
    }
    /** Birth Date. The format is ISO8601 with delimiters */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Date Expired. The format is ISO8601 with delimiters */
    get dateExpired() {
        return this.document.fields.find((f) => f.type.name === 'DateExpired');
    }
    /** Date Issued. The format is ISO8601 with delimiters */
    get dateIssued() {
        return this.document.fields.find((f) => f.type.name === 'DateIssued');
    }
    /** Document Code */
    get documentCode() {
        return this.document.fields.find((f) => f.type.name === 'DocumentCode');
    }
    /** First Name */
    get firstName() {
        return this.document.fields.find((f) => f.type.name === 'FirstName');
    }
    /** Last Name */
    get lastName() {
        return this.document.fields.find((f) => f.type.name === 'LastName');
    }
    /** Optional */
    get optional() {
        return this.document.fields.find((f) => f.type.name === 'Optional');
    }
}
/** GS1 */
export class GS1 {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return GS1DocumentType;
    }
    /** An array of all children of type "Element". */
    get elements() {
        return this.document.children
            .filter((c) => c.type.name === 'Element')
            .map((c) => new GS1.Element(c));
    }
}
(function (GS1) {
    /** GS1 Element */
    class Element {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return GS1ElementDocumentType;
        }
        /** Application Identifier */
        get applicationIdentifier() {
            return this.document.fields.find((f) => f.type.name === 'ApplicationIdentifier');
        }
        /** Data Title */
        get dataTitle() {
            return this.document.fields.find((f) => f.type.name === 'DataTitle');
        }
        /** Description */
        get elementDescription() {
            return this.document.fields.find((f) => f.type.name === 'ElementDescription');
        }
        /** Raw Value */
        get rawValue() {
            return this.document.fields.find((f) => f.type.name === 'RawValue');
        }
        /** An array of all children of type "ValidationError". */
        get validationErrors() {
            return this.document.children
                .filter((c) => c.type.name === 'ValidationError')
                .map((c) => new GS1.Element.ValidationError(c));
        }
    }
    GS1.Element = Element;
    (function (Element) {
        /** Validation Errors */
        class ValidationError {
            get document() {
                return this._document;
            }
            constructor(document) {
                if (document.type.name !== this.requiredDocumentType()) {
                    throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
                }
                this._document = document;
            }
            requiredDocumentType() {
                return GS1ElementValidationErrorDocumentType;
            }
            /** Error Code */
            get code() {
                return this.document.fields.find((f) => f.type.name === 'Code');
            }
            /** Reason */
            get reason() {
                return this.document.fields.find((f) => f.type.name === 'Reason');
            }
        }
        Element.ValidationError = ValidationError;
    })(Element = GS1.Element || (GS1.Element = {}));
})(GS1 || (GS1 = {}));
/** SEPA */
export class SEPA {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return SEPADocumentType;
    }
    /** Amount */
    get amount() {
        return this.document.fields.find((f) => f.type.name === 'Amount');
    }
    /** Character Set */
    get characterSet() {
        return this.document.fields.find((f) => f.type.name === 'CharacterSet');
    }
    /** Identification */
    get identification() {
        return this.document.fields.find((f) => f.type.name === 'Identification');
    }
    /** Information */
    get information() {
        return this.document.fields.find((f) => f.type.name === 'Information');
    }
    /** Amount */
    get purpose() {
        return this.document.fields.find((f) => f.type.name === 'Purpose');
    }
    /** Receiver BIC */
    get receiverBIC() {
        return this.document.fields.find((f) => f.type.name === 'ReceiverBIC');
    }
    /** Receiver IBAN */
    get receiverIBAN() {
        return this.document.fields.find((f) => f.type.name === 'ReceiverIBAN');
    }
    /** Receiver Name */
    get receiverName() {
        return this.document.fields.find((f) => f.type.name === 'ReceiverName');
    }
    /** Remittance */
    get remittance() {
        return this.document.fields.find((f) => f.type.name === 'Remittance');
    }
    /** Service Tag */
    get serviceTag() {
        return this.document.fields.find((f) => f.type.name === 'ServiceTag');
    }
    /** Version */
    get version() {
        return this.document.fields.find((f) => f.type.name === 'Version');
    }
}
/** Medical Certificate */
export class MedicalCertificate {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return MedicalCertificateDocumentType;
    }
    /** Accident */
    get accident() {
        return this.document.fields.find((f) => f.type.name === 'Accident');
    }
    /** Assigned To Accident Insurance Doctor */
    get assignedToAccidentInsuranceDoctor() {
        return this.document.fields.find((f) => f.type.name === 'AssignedToAccidentInsuranceDoctor');
    }
    /** Birth Date. The format is ISO8601 with delimiters */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Child Needs Care From */
    get childNeedsCareFrom() {
        return this.document.fields.find((f) => f.type.name === 'ChildNeedsCareFrom');
    }
    /** Child Needs Care Until */
    get childNeedsCareUntil() {
        return this.document.fields.find((f) => f.type.name === 'ChildNeedsCareUntil');
    }
    /** Diagnose */
    get diagnose() {
        return this.document.fields.find((f) => f.type.name === 'Diagnose');
    }
    /** Diagnosed On. The format is ISO8601 with delimiters */
    get diagnosedOn() {
        return this.document.fields.find((f) => f.type.name === 'DiagnosedOn');
    }
    /** Doctor Number */
    get doctorNumber() {
        return this.document.fields.find((f) => f.type.name === 'DoctorNumber');
    }
    /** Document Date. The format is ISO8601 with delimiters */
    get documentDate() {
        return this.document.fields.find((f) => f.type.name === 'DocumentDate');
    }
    /** First Name */
    get firstName() {
        return this.document.fields.find((f) => f.type.name === 'FirstName');
    }
    /** Health Insurance Number */
    get healthInsuranceNumber() {
        return this.document.fields.find((f) => f.type.name === 'HealthInsuranceNumber');
    }
    /** Incapable Of Work Since. The format is ISO8601 with delimiters */
    get incapableOfWorkSince() {
        return this.document.fields.find((f) => f.type.name === 'IncapableOfWorkSince');
    }
    /** Incapable Of Work Until. The format is ISO8601 with delimiters */
    get incapableOfWorkUntil() {
        return this.document.fields.find((f) => f.type.name === 'IncapableOfWorkUntil');
    }
    /** Initial Certificate */
    get initialCertificate() {
        return this.document.fields.find((f) => f.type.name === 'InitialCertificate');
    }
    /** Insured Person Number */
    get insuredPersonNumber() {
        return this.document.fields.find((f) => f.type.name === 'InsuredPersonNumber');
    }
    /** Last Name */
    get lastName() {
        return this.document.fields.find((f) => f.type.name === 'LastName');
    }
    /** Place Of Operation Number */
    get placeOfOperationNumber() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfOperationNumber');
    }
    /** Renewed Certificate */
    get renewedCertificate() {
        return this.document.fields.find((f) => f.type.name === 'RenewedCertificate');
    }
    /** Requires Care */
    get requiresCare() {
        return this.document.fields.find((f) => f.type.name === 'RequiresCare');
    }
    /** Status */
    get status() {
        return this.document.fields.find((f) => f.type.name === 'Status');
    }
    /** Work Accident */
    get workAccident() {
        return this.document.fields.find((f) => f.type.name === 'WorkAccident');
    }
}
/** VCard */
export class VCard {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return VCardDocumentType;
    }
    /** The child document of type "Version". */
    get version() {
        const child = this.document.children.find((c) => c.type.name === 'Version');
        return new VCard.Version(child);
    }
    /** An array of all children of type "Source". */
    get sources() {
        return this.document.children
            .filter((c) => c.type.name === 'Source')
            .map((c) => new VCard.Source(c));
    }
    /** The child document of type "Kind". */
    get kind() {
        const child = this.document.children.find((c) => c.type.name === 'Kind');
        return child ? new VCard.Kind(child) : undefined;
    }
    /** An array of all children of type "XML". */
    get xmls() {
        return this.document.children
            .filter((c) => c.type.name === 'XML')
            .map((c) => new VCard.XML(c));
    }
    /** The child document of type "Name". */
    get name() {
        const child = this.document.children.find((c) => c.type.name === 'Name');
        return child ? new VCard.Name(child) : undefined;
    }
    /** The child document of type "FormattedName". */
    get formattedName() {
        const child = this.document.children.find((c) => c.type.name === 'FormattedName');
        return child ? new VCard.FormattedName(child) : undefined;
    }
    /** An array of all children of type "Nickname". */
    get nicknames() {
        return this.document.children
            .filter((c) => c.type.name === 'Nickname')
            .map((c) => new VCard.Nickname(c));
    }
    /** The child document of type "Birthday". */
    get birthday() {
        const child = this.document.children.find((c) => c.type.name === 'Birthday');
        return child ? new VCard.Birthday(child) : undefined;
    }
    /** The child document of type "Anniversary". */
    get anniversary() {
        const child = this.document.children.find((c) => c.type.name === 'Anniversary');
        return child ? new VCard.Anniversary(child) : undefined;
    }
    /** The child document of type "Gender". */
    get gender() {
        const child = this.document.children.find((c) => c.type.name === 'Gender');
        return child ? new VCard.Gender(child) : undefined;
    }
    /** An array of all children of type "DeliveryAddress". */
    get deliveryAddresses() {
        return this.document.children
            .filter((c) => c.type.name === 'DeliveryAddress')
            .map((c) => new VCard.DeliveryAddress(c));
    }
    /** An array of all children of type "Label". */
    get labels() {
        return this.document.children
            .filter((c) => c.type.name === 'Label')
            .map((c) => new VCard.Label(c));
    }
    /** An array of all children of type "Photo". */
    get photos() {
        return this.document.children
            .filter((c) => c.type.name === 'Photo')
            .map((c) => new VCard.Photo(c));
    }
    /** An array of all children of type "TelephoneNumber". */
    get telephoneNumbers() {
        return this.document.children
            .filter((c) => c.type.name === 'TelephoneNumber')
            .map((c) => new VCard.TelephoneNumber(c));
    }
    /** An array of all children of type "Email". */
    get emails() {
        return this.document.children
            .filter((c) => c.type.name === 'Email')
            .map((c) => new VCard.Email(c));
    }
    /** An array of all children of type "IMPP". */
    get impps() {
        return this.document.children
            .filter((c) => c.type.name === 'IMPP')
            .map((c) => new VCard.IMPP(c));
    }
    /** An array of all children of type "Languages". */
    get languageses() {
        return this.document.children
            .filter((c) => c.type.name === 'Languages')
            .map((c) => new VCard.Languages(c));
    }
    /** An array of all children of type "TimeZone". */
    get timeZones() {
        return this.document.children
            .filter((c) => c.type.name === 'TimeZone')
            .map((c) => new VCard.TimeZone(c));
    }
    /** An array of all children of type "GeoLocation". */
    get geoLocations() {
        return this.document.children
            .filter((c) => c.type.name === 'GeoLocation')
            .map((c) => new VCard.GeoLocation(c));
    }
    /** An array of all children of type "Title". */
    get titles() {
        return this.document.children
            .filter((c) => c.type.name === 'Title')
            .map((c) => new VCard.Title(c));
    }
    /** An array of all children of type "Role". */
    get roles() {
        return this.document.children
            .filter((c) => c.type.name === 'Role')
            .map((c) => new VCard.Role(c));
    }
    /** An array of all children of type "Logo". */
    get logos() {
        return this.document.children
            .filter((c) => c.type.name === 'Logo')
            .map((c) => new VCard.Logo(c));
    }
    /** An array of all children of type "Agent". */
    get agents() {
        return this.document.children
            .filter((c) => c.type.name === 'Agent')
            .map((c) => new VCard.Agent(c));
    }
    /** An array of all children of type "Organisation". */
    get organisations() {
        return this.document.children
            .filter((c) => c.type.name === 'Organisation')
            .map((c) => new VCard.Organisation(c));
    }
    /** An array of all children of type "Member". */
    get members() {
        return this.document.children
            .filter((c) => c.type.name === 'Member')
            .map((c) => new VCard.Member(c));
    }
    /** An array of all children of type "Related". */
    get relateds() {
        return this.document.children
            .filter((c) => c.type.name === 'Related')
            .map((c) => new VCard.Related(c));
    }
    /** An array of all children of type "Categories". */
    get categorieses() {
        return this.document.children
            .filter((c) => c.type.name === 'Categories')
            .map((c) => new VCard.Categories(c));
    }
    /** An array of all children of type "Note". */
    get notes() {
        return this.document.children
            .filter((c) => c.type.name === 'Note')
            .map((c) => new VCard.Note(c));
    }
    /** The child document of type "ProductId". */
    get productId() {
        const child = this.document.children.find((c) => c.type.name === 'ProductId');
        return child ? new VCard.ProductId(child) : undefined;
    }
    /** The child document of type "Revision". */
    get revision() {
        const child = this.document.children.find((c) => c.type.name === 'Revision');
        return child ? new VCard.Revision(child) : undefined;
    }
    /** An array of all children of type "Sound". */
    get sounds() {
        return this.document.children
            .filter((c) => c.type.name === 'Sound')
            .map((c) => new VCard.Sound(c));
    }
    /** The child document of type "UID". */
    get uid() {
        const child = this.document.children.find((c) => c.type.name === 'UID');
        return child ? new VCard.UID(child) : undefined;
    }
    /** An array of all children of type "ClientPIDMap". */
    get clientPIDMaps() {
        return this.document.children
            .filter((c) => c.type.name === 'ClientPIDMap')
            .map((c) => new VCard.ClientPIDMap(c));
    }
    /** An array of all children of type "URL". */
    get urls() {
        return this.document.children
            .filter((c) => c.type.name === 'URL')
            .map((c) => new VCard.URL(c));
    }
    /** An array of all children of type "PublicKey". */
    get publicKeys() {
        return this.document.children
            .filter((c) => c.type.name === 'PublicKey')
            .map((c) => new VCard.PublicKey(c));
    }
    /** An array of all children of type "BusyTimeURL". */
    get busyTimeURLS() {
        return this.document.children
            .filter((c) => c.type.name === 'BusyTimeURL')
            .map((c) => new VCard.BusyTimeURL(c));
    }
    /** An array of all children of type "CalendarURIForRequests". */
    get calendarURIForRequestss() {
        return this.document.children
            .filter((c) => c.type.name === 'CalendarURIForRequests')
            .map((c) => new VCard.CalendarURIForRequests(c));
    }
    /** An array of all children of type "CalendarURI". */
    get calendarURwe() {
        return this.document.children
            .filter((c) => c.type.name === 'CalendarURI')
            .map((c) => new VCard.CalendarURI(c));
    }
    /** The child document of type "SortString". */
    get sortString() {
        const child = this.document.children.find((c) => c.type.name === 'SortString');
        return child ? new VCard.SortString(child) : undefined;
    }
    /** The child document of type "Classification". */
    get classification() {
        const child = this.document.children.find((c) => c.type.name === 'Classification');
        return child ? new VCard.Classification(child) : undefined;
    }
    /** An array of all children of type "Custom". */
    get customs() {
        return this.document.children
            .filter((c) => c.type.name === 'Custom')
            .map((c) => new VCard.Custom(c));
    }
}
(function (VCard) {
    /** VCard Entry */
    class Entry {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        /** Raw Value */
        get rawValue() {
            return this.document.fields.find((f) => f.type.name === 'RawValue');
        }
        /** Type Modifier */
        get typeModifiers() {
            return this.document.fields.filter((f) => f.type.name === 'TypeModifier');
        }
        /** Value */
        get values() {
            return this.document.fields.filter((f) => f.type.name === 'Value');
        }
    }
    VCard.Entry = Entry;
    /** Version */
    class Version extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardVersionDocumentType;
        }
    }
    VCard.Version = Version;
    /** Source */
    class Source extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardSourceDocumentType;
        }
    }
    VCard.Source = Source;
    /** Kind */
    class Kind extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardKindDocumentType;
        }
    }
    VCard.Kind = Kind;
    /** XML */
    class XML extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardXMLDocumentType;
        }
    }
    VCard.XML = XML;
    /** Name */
    class Name extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardNameDocumentType;
        }
    }
    VCard.Name = Name;
    /** Formatted Name */
    class FormattedName extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardFormattedNameDocumentType;
        }
    }
    VCard.FormattedName = FormattedName;
    /** Nickname */
    class Nickname extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardNicknameDocumentType;
        }
    }
    VCard.Nickname = Nickname;
    /** Birthday */
    class Birthday extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardBirthdayDocumentType;
        }
    }
    VCard.Birthday = Birthday;
    /** Anniversary */
    class Anniversary extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardAnniversaryDocumentType;
        }
    }
    VCard.Anniversary = Anniversary;
    /** Gender */
    class Gender extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardGenderDocumentType;
        }
    }
    VCard.Gender = Gender;
    /** Delivery Address */
    class DeliveryAddress extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardDeliveryAddressDocumentType;
        }
    }
    VCard.DeliveryAddress = DeliveryAddress;
    /** Label */
    class Label extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardLabelDocumentType;
        }
    }
    VCard.Label = Label;
    /** Photo */
    class Photo extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardPhotoDocumentType;
        }
    }
    VCard.Photo = Photo;
    /** Telephone Number */
    class TelephoneNumber extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardTelephoneNumberDocumentType;
        }
    }
    VCard.TelephoneNumber = TelephoneNumber;
    /** Email */
    class Email extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardEmailDocumentType;
        }
    }
    VCard.Email = Email;
    /** IMPP */
    class IMPP extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardIMPPDocumentType;
        }
    }
    VCard.IMPP = IMPP;
    /** Languages */
    class Languages extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardLanguagesDocumentType;
        }
    }
    VCard.Languages = Languages;
    /** Time Zone */
    class TimeZone extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardTimeZoneDocumentType;
        }
    }
    VCard.TimeZone = TimeZone;
    /** Geo Location */
    class GeoLocation extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardGeoLocationDocumentType;
        }
    }
    VCard.GeoLocation = GeoLocation;
    /** Title */
    class Title extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardTitleDocumentType;
        }
    }
    VCard.Title = Title;
    /** Role */
    class Role extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardRoleDocumentType;
        }
    }
    VCard.Role = Role;
    /** Logo */
    class Logo extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardLogoDocumentType;
        }
    }
    VCard.Logo = Logo;
    /** Agent */
    class Agent extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardAgentDocumentType;
        }
    }
    VCard.Agent = Agent;
    /** Organisation */
    class Organisation extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardOrganisationDocumentType;
        }
    }
    VCard.Organisation = Organisation;
    /** Member */
    class Member extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardMemberDocumentType;
        }
    }
    VCard.Member = Member;
    /** Related */
    class Related extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardRelatedDocumentType;
        }
    }
    VCard.Related = Related;
    /** Categories */
    class Categories extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardCategoriesDocumentType;
        }
    }
    VCard.Categories = Categories;
    /** Note */
    class Note extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardNoteDocumentType;
        }
    }
    VCard.Note = Note;
    /** ProductId */
    class ProductId extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardProductIdDocumentType;
        }
    }
    VCard.ProductId = ProductId;
    /** Revision */
    class Revision extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardRevisionDocumentType;
        }
    }
    VCard.Revision = Revision;
    /** Sound */
    class Sound extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardSoundDocumentType;
        }
    }
    VCard.Sound = Sound;
    /** UID */
    class UID extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardUIDDocumentType;
        }
    }
    VCard.UID = UID;
    /** Client PID Map */
    class ClientPIDMap extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardClientPIDMapDocumentType;
        }
    }
    VCard.ClientPIDMap = ClientPIDMap;
    /** URL */
    class URL extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardURLDocumentType;
        }
    }
    VCard.URL = URL;
    /** Public Key */
    class PublicKey extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardPublicKeyDocumentType;
        }
    }
    VCard.PublicKey = PublicKey;
    /** Busy Time URL */
    class BusyTimeURL extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardBusyTimeURLDocumentType;
        }
    }
    VCard.BusyTimeURL = BusyTimeURL;
    /** Calendar URI For Requests */
    class CalendarURIForRequests extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardCalendarURIForRequestsDocumentType;
        }
    }
    VCard.CalendarURIForRequests = CalendarURIForRequests;
    /** Calendar URI */
    class CalendarURI extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardCalendarURIDocumentType;
        }
    }
    VCard.CalendarURI = CalendarURI;
    /** Sort String */
    class SortString extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardSortStringDocumentType;
        }
    }
    VCard.SortString = SortString;
    /** Classification */
    class Classification extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardClassificationDocumentType;
        }
    }
    VCard.Classification = Classification;
    /** Custom */
    class Custom extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCardCustomDocumentType;
        }
    }
    VCard.Custom = Custom;
})(VCard || (VCard = {}));
/** AAMVA */
export class AAMVA {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return AAMVADocumentType;
    }
    /** Issuer Identification Number */
    get issuerIdentificationNumber() {
        return this.document.fields.find((f) => f.type.name === 'IssuerIdentificationNumber');
    }
    /** Jurisdiction Version Number */
    get jurisdictionVersionNumber() {
        return this.document.fields.find((f) => f.type.name === 'JurisdictionVersionNumber');
    }
    /** Version */
    get version() {
        return this.document.fields.find((f) => f.type.name === 'Version');
    }
    /** The child document of type "TitleData". */
    get titleData() {
        const child = this.document.children.find((c) => c.type.name === 'TitleData');
        return child ? new AAMVA.TitleData(child) : undefined;
    }
    /** The child document of type "RegistrationData". */
    get registrationData() {
        const child = this.document.children.find((c) => c.type.name === 'RegistrationData');
        return child ? new AAMVA.RegistrationData(child) : undefined;
    }
    /** The child document of type "MotorCarrierData". */
    get motorCarrierData() {
        const child = this.document.children.find((c) => c.type.name === 'MotorCarrierData');
        return child ? new AAMVA.MotorCarrierData(child) : undefined;
    }
    /** The child document of type "RegistrantAndVehicleData". */
    get registrantAndVehicleData() {
        const child = this.document.children.find((c) => c.type.name === 'RegistrantAndVehicleData');
        return child ? new AAMVA.RegistrantAndVehicleData(child) : undefined;
    }
    /** The child document of type "VehicleOwnerData". */
    get vehicleOwnerData() {
        const child = this.document.children.find((c) => c.type.name === 'VehicleOwnerData');
        return child ? new AAMVA.VehicleOwnerData(child) : undefined;
    }
    /** The child document of type "VehicleData". */
    get vehicleData() {
        const child = this.document.children.find((c) => c.type.name === 'VehicleData');
        return child ? new AAMVA.VehicleData(child) : undefined;
    }
    /** The child document of type "VehicleSafetyInspectionData". */
    get vehicleSafetyInspectionData() {
        const child = this.document.children.find((c) => c.type.name === 'VehicleSafetyInspectionData');
        return child ? new AAMVA.VehicleSafetyInspectionData(child) : undefined;
    }
    /** The child document of type "DriverLicense". */
    get driverLicense() {
        const child = this.document.children.find((c) => c.type.name === 'DriverLicense');
        return child ? new AAMVA.DriverLicense(child) : undefined;
    }
    /** The child document of type "IDCard". */
    get idCard() {
        const child = this.document.children.find((c) => c.type.name === 'IDCard');
        return child ? new AAMVA.IDCard(child) : undefined;
    }
    /** The child document of type "EnhancedDriverLicense". */
    get enhancedDriverLicense() {
        const child = this.document.children.find((c) => c.type.name === 'EnhancedDriverLicense');
        return child ? new AAMVA.EnhancedDriverLicense(child) : undefined;
    }
    /** The child document of type "RawDocument". */
    get rawDocument() {
        const child = this.document.children.find((c) => c.type.name === 'RawDocument');
        return new AAMVA.RawDocument(child);
    }
}
(function (AAMVA) {
    /** Title Data. File type "TD". */
    class TitleData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVATitleDataDocumentType;
        }
        /** Data element ID "NAT". City portion of the owner’s address. */
        get addressCity() {
            return this.document.fields.find((f) => f.type.name === 'AddressCity');
        }
        /** Data element ID "NAU". Jurisdiction portion of the owner’s address. */
        get addressJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressJurisdictionCode');
        }
        /** Data element ID "NAR". Street portion of the owner’s address. */
        get addressStreet() {
            return this.document.fields.find((f) => f.type.name === 'AddressStreet');
        }
        /** Data element ID "NAV". The ZIP code or Postal code portion of the owner’s address. */
        get addressZipCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressZipCode');
        }
        /** Data element ID "BBC". The name of business that owns the vehicle. */
        get businessName() {
            return this.document.fields.find((f) => f.type.name === 'BusinessName');
        }
        /** Data element ID "NAA". Family name (commonly called surname or last name) of the owner of the vehicle. */
        get familyName() {
            return this.document.fields.find((f) => f.type.name === 'FamilyName');
        }
        /** Data element ID "LAF". A code that uniquely identifies the first holder of a lien. */
        get firstLienHolderId() {
            return this.document.fields.find((f) => f.type.name === 'FirstLienHolderId');
        }
        /** Data element ID "LAA". Name of the first lien holder of the vehicle. */
        get firstLienHolderName() {
            return this.document.fields.find((f) => f.type.name === 'FirstLienHolderName');
        }
        /** Data element ID "NAE". Given name or names (includes all of what are commonly referred to as first and middle names) of the owner of the vehicle. */
        get givenName() {
            return this.document.fields.find((f) => f.type.name === 'GivenName');
        }
        /** Data element ID "TAW". This code represents whether the vehicle/vessel is new or used. Note: jurisdictions’ definitions of these classifications may vary a little due to state regulations on demo vehicles, slates between dealers, application of state taxes, etc. N = New, U = Used. */
        get newUsedIndicator() {
            return this.document.fields.find((f) => f.type.name === 'NewUsedIndicator');
        }
        /** Data element ID "TAH". The date the odometer reading was recorded by the jurisdiction. */
        get odometerDate() {
            return this.document.fields.find((f) => f.type.name === 'OdometerDate');
        }
        /** Data element ID "TAG". This is the federal odometer mileage disclosure. The mandatory information is: (1) Actual vehicle mileage; (2) Mileage exceeds mechanical limitations; (3) Not actual mileage; (4) Mileage disclosure not required. */
        get odometerDisclosure() {
            return this.document.fields.find((f) => f.type.name === 'OdometerDisclosure');
        }
        /** Data element ID "TAI". This is the odometer reading registered with the DMV either at the time of titling or registration renewal in kilometers. */
        get odometerReadingKilometers() {
            return this.document.fields.find((f) => f.type.name === 'OdometerReadingKilometers');
        }
        /** Data element ID "TAF". This is the odometer reading registered with the DMV either at the time of titling or registration renewal. */
        get odometerReadingMileage() {
            return this.document.fields.find((f) => f.type.name === 'OdometerReadingMileage');
        }
        /** Data element ID "TAZ". The title number assigned to the vehicle by the previous titling jurisdiction. */
        get previousTitleNumber() {
            return this.document.fields.find((f) => f.type.name === 'PreviousTitleNumber');
        }
        /** Data element ID "TPJ". The code for the jurisdiction (U.S., Canadian, or Mexican) that titled the vehicle immediately prior to the current titling jurisdiction. */
        get previousTitlingJurisdiction() {
            return this.document.fields.find((f) => f.type.name === 'PreviousTitlingJurisdiction');
        }
        /** Data element ID "TAY". Code providing information about the brand applied to the title. */
        get titleBrand() {
            return this.document.fields.find((f) => f.type.name === 'TitleBrand');
        }
        /** Data element ID "TAV". The date the jurisdiction’s titling authority issued a title to the owner of the vehicle. The format is CCYYMMDD. */
        get titleIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'TitleIssueDate');
        }
        /** Data element ID "TAA". The date the jurisdiction’s titling authority issued a title to the owner of the vehicle. The format is CCYYMMDD. */
        get titleNumber() {
            return this.document.fields.find((f) => f.type.name === 'TitleNumber');
        }
        /** Data element ID "TAC". A unique set of alphanumeric characters assigned by the titling jurisdiction to the certificate of title of a vehicle. */
        get titlingJurisdiction() {
            return this.document.fields.find((f) => f.type.name === 'TitlingJurisdiction');
        }
        /** Data element ID "VAO". The general configuration or shape of a vehicle distinguished by characteristics such as number of doors, seats, windows, roofline, and type of top. The vehicle body type is 2-character alphanumeric. */
        get vehicleBodyStyle() {
            return this.document.fields.find((f) => f.type.name === 'VehicleBodyStyle');
        }
        /** Data element ID "VBD". Where the vehicle/vessel is one color, this is the appropriate code describing that color. When the vehicle is two colors, this is the code for the top-most or front-most color. */
        get vehicleColor() {
            return this.document.fields.find((f) => f.type.name === 'VehicleColor');
        }
        /** Data element ID "VAD". A unique combination of alphanumeric characters that identifies a specific vehicle or component. The VIN is affixed to the vehicle in specific locations and formulated by the manufacturer. State agencies under some controlled instances may assign a VIN to a vehicle. */
        get vehicleIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdentificationNumber');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "VAM". A code denoting a family of vehicles (within a make), which has a degree of similarity in construction, such as body, chassis, etc. The field does not necessarily contain a standard code; it may contain a value provided by the originator of the field. */
        get vehicleModel() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModel');
        }
        /** Data element ID "VAL". The year that is assigned to a vehicle by the manufacturer. The format is CCYY. */
        get vehicleModelYear() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModelYear');
        }
        /** Data element ID "TAU". The date a vehicle was purchased by the current owner. The format is ISO8601 with delimiters. */
        get vehiclePurchaseDate() {
            return this.document.fields.find((f) => f.type.name === 'VehiclePurchaseDate');
        }
    }
    AAMVA.TitleData = TitleData;
    /** Registration Data. File type "RG". */
    class RegistrationData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVARegistrationDataDocumentType;
        }
        /** Data element ID "RBK". City portion of the owner’s address. */
        get addressCity() {
            return this.document.fields.find((f) => f.type.name === 'AddressCity');
        }
        /** Data element ID "RBL". Jurisdiction portion of the owner’s address. */
        get addressJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressJurisdictionCode');
        }
        /** Data element ID "RBI". Street portion of the owner’s address. */
        get addressStreet() {
            return this.document.fields.find((f) => f.type.name === 'AddressStreet');
        }
        /** Data element ID "RBM". The Zip code or Postal code of the vehicle owner’s residence address. */
        get addressZipCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressZipCode');
        }
        /** Data element ID "VBC". The number of common axles of rotation of one or more wheels of a vehicle, whether power driven or freely rotating. */
        get axles() {
            return this.document.fields.find((f) => f.type.name === 'Axles');
        }
        /** Data element ID "BBC". The business name of the first registrant of a vehicle. */
        get businessName() {
            return this.document.fields.find((f) => f.type.name === 'BusinessName');
        }
        /** Data element ID "FUL". The type of fuel used by the vehicle. In most cases, the fuel type would be diesel. */
        get fuel() {
            return this.document.fields.find((f) => f.type.name === 'Fuel');
        }
        /** Data element ID "VAT". The unladen weight of the vehicle (e.g., the single-unit truck, truck combination) plus the weight of the load being carried at a specific point in time. */
        get grossVehicleWeight() {
            return this.document.fields.find((f) => f.type.name === 'GrossVehicleWeight');
        }
        /** Data element ID "RBD". Family name (commonly called surname or last name) of the registered owner of a vehicle. */
        get registrantFamilyName() {
            return this.document.fields.find((f) => f.type.name === 'RegistrantFamilyName');
        }
        /** Data element ID "RBE". Given name or names (includes all of what are commonly referred to as first and middle names) of the registered owner of a vehicle. */
        get registrantGivenName() {
            return this.document.fields.find((f) => f.type.name === 'RegistrantGivenName');
        }
        /** Data element ID "RAG". The date in which the registration expired. The format is ISO8601 with delimiters. */
        get registrationExpiryDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationExpiryDate');
        }
        /** Data element ID "RBB". The date in which the registration was issued. The format is ISO8601 with delimiters. */
        get registrationIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationIssueDate');
        }
        /** Data element ID "RAM". The characters assigned to a registration plate or tag affixed to the vehicle, assigned by the jurisdiction. */
        get registrationPlateNumber() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationPlateNumber');
        }
        /** Data element ID "RBU". A unique number printed on the tab/decal and stored as part of the registration record. */
        get registrationWindowStickerDecal() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationWindowStickerDecal');
        }
        /** Data element ID "RBT". The year of registration. */
        get registrationYear() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationYear');
        }
        /** Data element ID "VAO". The general configuration or shape of a vehicle distinguished by characteristics such as number of doors, seats, windows, roofline, and type of top. The vehicle body type is 2-character alphanumeric. */
        get vehicleBodyStyle() {
            return this.document.fields.find((f) => f.type.name === 'VehicleBodyStyle');
        }
        /** Data element ID "VBD". Where the vehicle is one color, this is the appropriate code describing that color. When the vehicle is two colors, this is the code for the top-most or front-most color. */
        get vehicleColor() {
            return this.document.fields.find((f) => f.type.name === 'VehicleColor');
        }
        /** Data element ID "VAD". A unique combination of alphanumeric characters that identifies a specific vehicle or component. The VIN is affixed to the vehicle in specific locations and formulated by the manufacturer. State agencies under some controlled instances my assign a VIN to a vehicle. */
        get vehicleIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdentificationNumber');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "VAM". A code denoting a family of vehicles (within a make), which has a degree of similarity in construction, such as body, chassis, etc. The field does not necessarily contain a standard code; it may contain a value provided by the originator of the field. */
        get vehicleModel() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModel');
        }
        /** Data element ID "VAL". The year which is assigned to a vehicle by the manufacturer. The format is CCYY. */
        get vehicleModelYear() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModelYear');
        }
        /** Data element ID "VPC". Indicates the use of the vehicle. */
        get vehicleUse() {
            return this.document.fields.find((f) => f.type.name === 'VehicleUse');
        }
    }
    AAMVA.RegistrationData = RegistrationData;
    /** Motor Carrier Data. File type "MC". */
    class MotorCarrierData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVAMotorCarrierDataDocumentType;
        }
        /** Data element ID "MAA". The name of the carrier responsible for safety. This can be an individual, partnership or corporation responsible for the transportation of persons or property. This is the name that is recognized by law. */
        get carrierName() {
            return this.document.fields.find((f) => f.type.name === 'CarrierName');
        }
        /** Data element ID "MAL". This is the city for the mailing address of the individual carrier. This information is utilized by the base jurisdiction to send information to the carrier that purchased the IRP credentials. */
        get city() {
            return this.document.fields.find((f) => f.type.name === 'City');
        }
        /** Data element ID "MAI". This is the jurisdiction of the residential address of the individual carrier. This information is utilized by the base jurisdiction to send information to the carrier that purchased the IRP credentials. */
        get jurisdiction() {
            return this.document.fields.find((f) => f.type.name === 'Jurisdiction');
        }
        /** Data element ID "MAK". This is the mailing address of the individual carrier. This information is utilized by the base jurisdiction to send information to the carrier that purchased the IRP credentials. */
        get streetAddress() {
            return this.document.fields.find((f) => f.type.name === 'StreetAddress');
        }
        /** Data element ID "MAN". A unique identifier assigned to the carrier responsible for safety issued by the U.S. Department of Transportation – Federal Motor Carrier Safety Administration. */
        get usdotNumber() {
            return this.document.fields.find((f) => f.type.name === 'USDOTNumber');
        }
        /** Data element ID "MAO". The ZIP or Postal code of the resident address of the vehicle owner. */
        get zip() {
            return this.document.fields.find((f) => f.type.name === 'Zip');
        }
    }
    AAMVA.MotorCarrierData = MotorCarrierData;
    /** Registrant And Vehicle Data. File type "IR". */
    class RegistrantAndVehicleData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVARegistrantAndVehicleDataDocumentType;
        }
        /** Data element ID "RBI". The first line of the registrant’s residence address. */
        get address() {
            return this.document.fields.find((f) => f.type.name === 'Address');
        }
        /** Data element ID "RAU". The declared base jurisdiction registration weight. */
        get baseJurisdictionRegisteredWeight() {
            return this.document.fields.find((f) => f.type.name === 'BaseJurisdictionRegisteredWeight');
        }
        /** Data element ID "RBC". The name of the first registrant of a vehicle. Registrant’s name may be a combined individual name or the name of a business */
        get carrierNameRegistrant() {
            return this.document.fields.find((f) => f.type.name === 'CarrierNameRegistrant');
        }
        /** Data element ID "RBK". The registrant’s residence city name. */
        get city() {
            return this.document.fields.find((f) => f.type.name === 'City');
        }
        /** Data element ID "VAT". The unladen weight of the vehicle (e.g., single-unit truck, truck combination) plus the weight of the maximum load for which vehicle registration fees have been paid within a particular jurisdiction. */
        get grossVehicleWeight() {
            return this.document.fields.find((f) => f.type.name === 'GrossVehicleWeight');
        }
        /** Data element ID "RBL". The state or province of the registrant’s residence address. */
        get jurisdiction() {
            return this.document.fields.find((f) => f.type.name === 'Jurisdiction');
        }
        /** Data element ID "VAL". The year which is assigned to a vehicle by the manufacturer. The format is YY. */
        get modelYear() {
            return this.document.fields.find((f) => f.type.name === 'ModelYear');
        }
        /** Data element IDs "RAP", "VBC". The seat capacity of a commercial vehicle designed for transportation of more than then passengers. The number of common axles of rotation of one or more wheels of a vehicle, whether power design or freely rotating. */
        get numberOfSeats() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfSeats');
        }
        /** Data element ID "RAD". The number assigned to the registration decal in those jurisdictions that issue decals. */
        get registrationDecalNumber() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationDecalNumber');
        }
        /** Data element ID "RAF". The registration enforcement date is the date that the current registration was enforced. This may or may not be the original registration date. The format is ISO8601 with delimiters */
        get registrationEnforcementDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationEnforcementDate');
        }
        /** Data element ID "RAG". The date in which the registration expired. The format is ISO8601 with delimiters. */
        get registrationExpirationDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationExpirationDate');
        }
        /** Data element ID "IFJ". The date in which the registration was issued. The format is ISO8601 with delimiters. */
        get registrationIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationIssueDate');
        }
        /** Data element ID "RAM". The characters assigned to a registration plate or tag affixed to the vehicle, assigned by the jurisdiction. */
        get registrationPlateNumber() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationPlateNumber');
        }
        /** Data element ID "RBT". This field is the registration year assigned by the jurisdiction. The format is CCYY. */
        get registrationYear() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationYear');
        }
        /** Data element ID "VBB". The type of vehicle operated for the transportation of persons or property in the furtherance of any commercial or industrial enterprise, for hire or not for hire. Not all states will use all values. */
        get typeOfVehicle() {
            return this.document.fields.find((f) => f.type.name === 'TypeOfVehicle');
        }
        /** Data element ID "IEG". A number, assigned by the registrant of the commercial vehicle or trailer, to identify the vehicle or trailer in the fleet. No two units in a fleet can have the same number. A.K.A vehicle unit number or owner’s equipment number. */
        get unitNumber() {
            return this.document.fields.find((f) => f.type.name === 'UnitNumber');
        }
        /** Data element ID "VAD". A unique combination of alphanumeric characters that identifies a specific vehicle or component. The VIN is affixed to the vehicle in specific locations and formulated by the manufacturer. State agencies under some controlled instances may assign a VIN to a vehicle. */
        get vehicleIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdentificationNumber');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "RBM". The ZIP or Postal code of the resident address of the registrant. */
        get zipCode() {
            return this.document.fields.find((f) => f.type.name === 'ZipCode');
        }
    }
    AAMVA.RegistrantAndVehicleData = RegistrantAndVehicleData;
    /** Vehicle Owner Data. File type "OW". */
    class VehicleOwnerData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVAVehicleOwnerDataDocumentType;
        }
        /** Data element ID "NAX". The unique customer number/ID of the first vehicle owner. */
        get firstOwnerIdNumber() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerIdNumber');
        }
        /** Data element ID "NAB". Last Name or Surname of the Owner. Hyphenated names acceptable, spaces between names acceptable, but no other use of special symbols. */
        get firstOwnerLastName() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerLastName');
        }
        /** Data element ID "NBA". The legal status of the first vehicle owner. This is only used when a vehicle has multiple owners. A legal status may be ("AND", "OR"). */
        get firstOwnerLegalStatus() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerLegalStatus');
        }
        /** Data element ID "NAD". Middle Name(s) or Initial(s) of the Owner. Hyphenated names acceptable, spaces, between names acceptable, but no other use of special symbols. */
        get firstOwnerMiddleName() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerMiddleName');
        }
        /** Data element ID "NAC". First Name or Given Name of the Owner. Hyphenated names acceptable, but no other use of special symbols. */
        get firstOwnerName() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerName');
        }
        /** Data element ID "NAA". Name of the (or one of the) individual(s) who owns the Vehicle as defined in the ANSI D- 20 Data Element Dictionary. (Lastname@Firstname@MI@Suffix if any.) */
        get firstOwnerTotalName() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerTotalName');
        }
        /** Data element ID "NAR". Street address line 1. (Mailing) */
        get mailingAddress1() {
            return this.document.fields.find((f) => f.type.name === 'MailingAddress1');
        }
        /** Data element ID "NAS". Street address line 2. (Mailing) */
        get mailingAddress2() {
            return this.document.fields.find((f) => f.type.name === 'MailingAddress2');
        }
        /** Data element ID "NAT". Name of city for mailing address. */
        get mailingCity() {
            return this.document.fields.find((f) => f.type.name === 'MailingCity');
        }
        /** Data element ID "NAU". Jurisdiction code for mailing address. Conforms to Canadian, Mexican and US jurisdictions as appropriate. Codes for provinces (Canada) and states (US and Mexico). */
        get mailingJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'MailingJurisdictionCode');
        }
        /** Data element ID "NAV". The ZIP code or Postal code used for mailing. (As used by Canadian, Mexican and US jurisdictions.) */
        get mailingZipCode() {
            return this.document.fields.find((f) => f.type.name === 'MailingZipCode');
        }
        /** Data element ID "NAM". Street address line 1. (Mailing) */
        get residenceAddress1() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceAddress1');
        }
        /** Data element ID "NAN". Street address line 2. (Mailing) */
        get residenceAddress2() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceAddress2');
        }
        /** Data element ID "NAO". Name of city for mailing address. */
        get residenceCity() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceCity');
        }
        /** Data element ID "NAP". Jurisdiction code for mailing address. Conforms to Canadian, Mexican and US jurisdictions as appropriate. Codes for provinces (Canada) and states (US and Mexico). */
        get residenceJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceJurisdictionCode');
        }
        /** Data element ID "NAQ". The ZIP code or Postal code used for mailing. (As used by Canadian, Mexican and US jurisdictions). */
        get residenceZipCode() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceZipCode');
        }
        /** Data element ID "NAY". The unique customer number/ID of the second vehicle owner. */
        get secondOwnerIdNumber() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerIdNumber');
        }
        /** Data element ID "NAF". Last Name or Surname of the Owner. Hyphenated names acceptable, spaces between names acceptable, but no other use of special symbols. */
        get secondOwnerLastName() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerLastName');
        }
        /** Data element ID "NBB". The legal status of the second vehicle owner. This is only used when a vehicle has multiple owners. A legal status may be ("AND", "OR"). */
        get secondOwnerLegalStatus() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerLegalStatus');
        }
        /** Data element ID "NAH". Middle Name(s) or Initial(s) of the Owner. Hyphenated names acceptable, spaces between names acceptable, but no other use of special symbols. */
        get secondOwnerMiddleName() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerMiddleName');
        }
        /** Data element ID "NAG". First Name or Given Name of the Owner. Hyphenated names acceptable, but no other use of special symbols. */
        get secondOwnerName() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerName');
        }
        /** Data element ID "NAE". Name of the (or one of the) individual(s) who owns the Vehicle as defined in the ANSI D- 20 Data Element Dictionary. (Lastname@Firstname@MI@Suffix if any.) */
        get secondOwnerTotalName() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerTotalName');
        }
    }
    AAMVA.VehicleOwnerData = VehicleOwnerData;
    /** Vehicle Data. File type "VH". */
    class VehicleData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVAVehicleDataDocumentType;
        }
        /** Data element ID "VAO". Vehicle manufacture body style. */
        get bodyStyle() {
            return this.document.fields.find((f) => f.type.name === 'BodyStyle');
        }
        /** Data element ID "VAG". Date vehicle reported junked. The format is ISO8601 with delimiters. */
        get dateJunked() {
            return this.document.fields.find((f) => f.type.name === 'DateJunked');
        }
        /** Data element ID "VAJ". Date vehicle reported recovered. The format is ISO8601 with delimiters. */
        get dateRecovered() {
            return this.document.fields.find((f) => f.type.name === 'DateRecovered');
        }
        /** Data element ID "VAI". Date vehicle reported stolen. The format is ISO8601 with delimiters. */
        get dateStolen() {
            return this.document.fields.find((f) => f.type.name === 'DateStolen');
        }
        /** Data element ID "VAW". Manufacturer’s rated engine displacement. */
        get engineDisplacement() {
            return this.document.fields.find((f) => f.type.name === 'EngineDisplacement');
        }
        /** Data element ID "VAR". The size of a vehicle’s engine. */
        get engineSize() {
            return this.document.fields.find((f) => f.type.name === 'EngineSize');
        }
        /** Data element ID "VAN". Type of fuel the vehicle utilizes. */
        get fuelType() {
            return this.document.fields.find((f) => f.type.name === 'FuelType');
        }
        /** Data element ID "VAU". Manufacturer’s rated horsepower. */
        get horsepower() {
            return this.document.fields.find((f) => f.type.name === 'Horsepower');
        }
        /** Data element ID "VAY". International fuel tax indicator */
        get iftaIndicator() {
            return this.document.fields.find((f) => f.type.name === 'IFTAIndicator');
        }
        /** Data element ID "VAX". International registration plan indicator. */
        get irpIndicator() {
            return this.document.fields.find((f) => f.type.name === 'IRPIndicator');
        }
        /** Data element ID "VAF". Vehicle has been junked. */
        get junkedIndicator() {
            return this.document.fields.find((f) => f.type.name === 'JunkedIndicator');
        }
        /** Data element ID "VAE". Manufacturer’s Suggested Retail Price. No decimal places. Right Justified Zero or space fill. */
        get msrp() {
            return this.document.fields.find((f) => f.type.name === 'MSRP');
        }
        /** Data element ID "VAA". State to provide definition. */
        get majorCode() {
            return this.document.fields.find((f) => f.type.name === 'MajorCode');
        }
        /** Data element ID "VAL". Vehicle manufacture year. */
        get makeYear() {
            return this.document.fields.find((f) => f.type.name === 'MakeYear');
        }
        /** Data element ID "VAT". Manufacturer’s gross vehicle weight rating. */
        get manufactureGrossWeight() {
            return this.document.fields.find((f) => f.type.name === 'ManufactureGrossWeight');
        }
        /** Data element ID "VAB". State to provide definition. */
        get minorCode() {
            return this.document.fields.find((f) => f.type.name === 'MinorCode');
        }
        /** Data element ID "VBC". Number of axles the vehicle has. */
        get numberOfAxles() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfAxles');
        }
        /** Data element ID "VAQ". Number of cylinders the vehicle has. */
        get numberOfCylinders() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfCylinders');
        }
        /** Data element ID "VAP". Number of doors on the vehicle. */
        get numberOfDoors() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfDoors');
        }
        /** Data element ID "VAH". Indicates stolen vehicle. */
        get stolenIndicator() {
            return this.document.fields.find((f) => f.type.name === 'StolenIndicator');
        }
        /** Data element ID "VAC". Type of transmission the vehicle carries. */
        get transmissionCode() {
            return this.document.fields.find((f) => f.type.name === 'TransmissionCode');
        }
        /** Data element ID "VAV". Gross weight of the vehicle unloaded. */
        get unladenWeight() {
            return this.document.fields.find((f) => f.type.name === 'UnladenWeight');
        }
        /** Data element ID "VAZ". Vehicle license tax calculation from date of purchase. */
        get vltClacFromDate() {
            return this.document.fields.find((f) => f.type.name === 'VLTClacFromDate');
        }
        /** Data element ID "VBA". Unique number to identify the vehicle record. */
        get vehicleIdNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdNumber');
        }
        /** Data element ID "VAD". A unique combination of alphanumeric characters that identifies a specific vehicle or component. The VIN is affixed to the vehicle in specific locations and formulated by the manufacturer. State agencies under some controlled instances may assign a VIN to a vehicle. */
        get vehicleIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdentificationNumber');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "VAM". Vehicle manufacture model. */
        get vehicleModel() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModel');
        }
        /** Data element ID "VAS". This is the status of the vehicle (e.g., active, suspend, etc.) */
        get vehicleStatusCode() {
            return this.document.fields.find((f) => f.type.name === 'VehicleStatusCode');
        }
        /** Data element ID "VBB". EPA vehicle classification. */
        get vehicleTypeCode() {
            return this.document.fields.find((f) => f.type.name === 'VehicleTypeCode');
        }
    }
    AAMVA.VehicleData = VehicleData;
    /** Vehicle Safety Inspection Data. File type "VS". */
    class VehicleSafetyInspectionData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVAVehicleSafetyInspectionDataDocumentType;
        }
        /** Data element ID "IAN". The street name and number, city, state and zip code of the inspection facility. */
        get inspectionAddress() {
            return this.document.fields.find((f) => f.type.name === 'InspectionAddress');
        }
        /** Data element ID "IPD". Identifies whether the pollution control devices meet the minimum inspection criteria. */
        get inspectionAirPollutionDeviceConditions() {
            return this.document.fields.find((f) => f.type.name === 'InspectionAirPollutionDeviceConditions');
        }
        /** Data element ID "IFI". The unique number assigned to an inspection facility. */
        get inspectionFacilityIdentifier() {
            return this.document.fields.find((f) => f.type.name === 'InspectionFacilityIdentifier');
        }
        /** Data element ID "INC". A unique number assigned to a current vehicle inspection form for identification purposes or a preprinted unique number on the motor vehicle inspection sticker currently issued to a motor vehicle which has passed inspection. */
        get inspectionFormOrStickerNumberCurrent() {
            return this.document.fields.find((f) => f.type.name === 'InspectionFormOrStickerNumberCurrent');
        }
        /** Data element ID "INP". The number of the last inspection form excluding the current inspection or the certification number of the last inspection sticker, excluding the current inspection. */
        get inspectionFormOrStickerNumberPrevious() {
            return this.document.fields.find((f) => f.type.name === 'InspectionFormOrStickerNumberPrevious');
        }
        /** Data element ID "ISC". An indicator that specifies whether or not the vehicle has a current smog certificate. */
        get inspectionSmogCertificateIndicator() {
            return this.document.fields.find((f) => f.type.name === 'InspectionSmogCertificateIndicator');
        }
        /** Data element ID "ISN". Station number performing the inspection. */
        get inspectionStationNumber() {
            return this.document.fields.find((f) => f.type.name === 'InspectionStationNumber');
        }
        /** Data element ID "IIN". A unique number assigned to each licensed vehicle inspector. */
        get inspectorIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'InspectorIdentificationNumber');
        }
        /** Data element ID "ORI". The vehicle’s odometer reading (to the nearest mile or kilometer) at the time of inspection. */
        get odometerReadingAtInspection() {
            return this.document.fields.find((f) => f.type.name === 'OdometerReadingAtInspection');
        }
        /** Data element ID "VAO". The general configuration or shape of a vehicle distinguished by characteristics such as number of doors, seats, windows, roofline, and type of top. The vehicle body type is 2- character alphanumeric. */
        get vehicleBodyType() {
            return this.document.fields.find((f) => f.type.name === 'VehicleBodyType');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "VAL". The year which is assigned to a vehicle by the manufacturer. The format is CCYY. */
        get vehicleModelYear() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModelYear');
        }
    }
    AAMVA.VehicleSafetyInspectionData = VehicleSafetyInspectionData;
    /** Driver License Or ID Document */
    class DLID {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        /** Data element ID "DAI". City portion of the cardholder address. */
        get addressCity() {
            return this.document.fields.find((f) => f.type.name === 'AddressCity');
        }
        /** Data element ID "DAJ". State portion of the cardholder address. */
        get addressJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressJurisdictionCode');
        }
        /** Data element ID "DAK". Postal code portion of the cardholder address in the U.S. and Canada. If the trailing portion of the postal code in the U.S. is not known, zeros will be used to fill the trailing set of numbers up to nine (9) digits. */
        get addressPostalCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressPostalCode');
        }
        /** Data element ID "DAG". Street portion of the cardholder address. */
        get addressStreet1() {
            return this.document.fields.find((f) => f.type.name === 'AddressStreet1');
        }
        /** Data element ID "DAH". Second line of street portion of the cardholder address. */
        get addressStreet2() {
            return this.document.fields.find((f) => f.type.name === 'AddressStreet2');
        }
        /** Data element ID "DCJ". A string of letters and/or numbers that identifies when, where, and by whom a driver license/ID card was made. If audit information is not used on the card or the MRT, it must be included in the driver record. */
        get adultInformation() {
            return this.document.fields.find((f) => f.type.name === 'AdultInformation');
        }
        /** Data element ID "DBN". Other family name by which cardholder is known. */
        get aliasFamilyName() {
            return this.document.fields.find((f) => f.type.name === 'AliasFamilyName');
        }
        /** Data element ID "DBG". Other given name by which cardholder is known. */
        get aliasGivenName() {
            return this.document.fields.find((f) => f.type.name === 'AliasGivenName');
        }
        /** Data element ID "DBQ". Other middle name by which cardholder is known. */
        get aliasMiddleName() {
            return this.document.fields.find((f) => f.type.name === 'AliasMiddleName');
        }
        /** Data element ID "DBR". Other prefix by which cardholder is known. */
        get aliasPrefixName() {
            return this.document.fields.find((f) => f.type.name === 'AliasPrefixName');
        }
        /** Data element ID "DBS". Other suffix by which cardholder is known. */
        get aliasSuffixName() {
            return this.document.fields.find((f) => f.type.name === 'AliasSuffixName');
        }
        /** Data element ID "DDB". DHS required field that indicates date of the most recent version change or modification to the visible format of the DL/ID. The format is ISO8601 with delimiters. */
        get cardRevisionDate() {
            return this.document.fields.find((f) => f.type.name === 'CardRevisionDate');
        }
        /** Data element ID "DDA". DHS required field that indicates compliance: "F" = compliant; and, "N" = non-compliant. */
        get complianceType() {
            return this.document.fields.find((f) => f.type.name === 'ComplianceType');
        }
        /** Data element ID "DCG". Country in which DL/ID is issued. U.S. = USA, Canada = CAN. */
        get countryIdentification() {
            return this.document.fields.find((f) => f.type.name === 'CountryIdentification');
        }
        /** Data element ID "DCS". Family name of the cardholder. (Family name is sometimes also called “last name” or “surname.”) Collect full name for record, print as many characters as possible on portrait side of DL/ID. */
        get customerFamilyName() {
            return this.document.fields.find((f) => f.type.name === 'CustomerFamilyName');
        }
        /** Data element ID "DAC". First name of the cardholder. */
        get customerFirstName() {
            return this.document.fields.find((f) => f.type.name === 'CustomerFirstName');
        }
        /** Data element ID "DCT". Given names of the cardholder. (Given names include all names other than the Family Name. This includes all those names sometimes also called “first” and “middle” names.) */
        get customerGivenNames() {
            return this.document.fields.find((f) => f.type.name === 'CustomerGivenNames');
        }
        /** Data element ID "DAQ". The number assigned or calculated by the issuing authority. */
        get customerIdNumber() {
            return this.document.fields.find((f) => f.type.name === 'CustomerIdNumber');
        }
        /** Data element ID "DAD". Middle name(s) of the cardholder. In the case of multiple middle names they shall be separated by a comma “,”. */
        get customerMiddleName() {
            return this.document.fields.find((f) => f.type.name === 'CustomerMiddleName');
        }
        /** Data element ID "DBB". Date on which the cardholder was born. The format is ISO8601 with delimiters. */
        get dateOfBirth() {
            return this.document.fields.find((f) => f.type.name === 'DateOfBirth');
        }
        /** Data element ID "DCF". Number must uniquely identify a particular document issued to that customer from others that may have been issued in the past. This number may serve multiple purposes of document discrimination, audit information number, and/or inventory control. */
        get documentDiscriminator() {
            return this.document.fields.find((f) => f.type.name === 'DocumentDiscriminator');
        }
        /** Data element ID "DBA". Date on which the driving and identification privileges granted by the document are no longer valid. The format is ISO8601 with delimtiers. */
        get documentExpirationDate() {
            return this.document.fields.find((f) => f.type.name === 'DocumentExpirationDate');
        }
        /** Data element ID "DBD". Date on which the document was issued. The format is ISO8601 with delimiters. */
        get documentIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'DocumentIssueDate');
        }
        /** Data element ID "DBL". Alternative dates given as date of birth. */
        get driverAliasDateOfBirthField() {
            return this.document.fields.find((f) => f.type.name === 'DriverAliasDateOfBirthField');
        }
        /** Data element ID "DBP". Alternative fist name or given name of the individual holding the Driver License or ID. Hyphenated names acceptable, but no other use of special symbols. */
        get driverAliasFirstName() {
            return this.document.fields.find((f) => f.type.name === 'DriverAliasFirstName');
        }
        /** Data element ID "DBO". Alternative last name or surname of the individual holding the Driver License or ID. Hyphenated names acceptable, but no other use of special symbols. */
        get driverAliasLastName() {
            return this.document.fields.find((f) => f.type.name === 'DriverAliasLastName');
        }
        /** Data element ID "DBM". DriverAliasSocialSecurityNumber */
        get driverAliasSocialSecurityNumber() {
            return this.document.fields.find((f) => f.type.name === 'DriverAliasSocialSecurityNumber');
        }
        /** Data element ID "DAB". Last name or surname of the individual holding the Driver License or ID. Hyphenated names acceptable, but no other use of special symbols. */
        get driverLastName() {
            return this.document.fields.find((f) => f.type.name === 'DriverLastName');
        }
        /** Data element ID "DAR". A=Class A; B=Class B; C=Class C (Class A, B and C are defined by Federal Highway regulations); M=Class M motorcycle as defined by AAMVA; others are defined by DL Classification Code Standards. */
        get driverLicenseClassificationCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverLicenseClassificationCode');
        }
        /** Data element ID "DAT". Any endorsements on a driver license which authorize the operation of specified types of vehicles or the operation of vehicles carrying specified loads. Endorsements shall be specific to classification of a driver license. */
        get driverLicenseEndorsementsCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverLicenseEndorsementsCode');
        }
        /** Data element ID "DAA". Name of the individual holding the Driver License or ID as defined in ANSI D20 Data Dictionary. (Lastname@Firstname@MI@ suffix if any) (Machine, Mag Stripe uses ‘$’ and Bar Code uses ‘,’ in place of ‘@’) Firstname, Middle Initial, Lastname (Human) */
        get driverLicenseName() {
            return this.document.fields.find((f) => f.type.name === 'DriverLicenseName');
        }
        /** Data element ID "DAS". A restriction applicable to a driver license. */
        get driverLicenseRestrictionCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverLicenseRestrictionCode');
        }
        /** Data element ID "DAF". Prefix to Driver Name. Not defined in ANSI D20. Freeform as defined by issuing jurisdiction. */
        get driverNamePrefix() {
            return this.document.fields.find((f) => f.type.name === 'DriverNamePrefix');
        }
        /** Data element ID "DAE". An affix occurring at the end of a word, e.g.; Sr., Jr., II, III, IV, etc. */
        get driverNameSuffix() {
            return this.document.fields.find((f) => f.type.name === 'DriverNameSuffix');
        }
        /** Data element ID "PAA". Identifies the type of permit as defined by ANSI D20. */
        get driverPermitClassificationCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverPermitClassificationCode');
        }
        /** Data element ID "PAF". Permit endorsements as defined by ANSI D20. */
        get driverPermitEndorsementCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverPermitEndorsementCode');
        }
        /** Data element ID "PAD".  Date permit was issued. The format is ISO8601 with delimiters. */
        get driverPermitIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'DriverPermitIssueDate');
        }
        /** Data element ID "PAE". Permit restrictions as defined by ANSI D20. */
        get driverPermitRestrictionCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverPermitRestrictionCode');
        }
        /** Data element ID "DAN". Name of city for mailing address. */
        get driverResidenceCity() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidenceCity');
        }
        /** Data element ID "DAO". Jurisdiction code for mailing address. Conforms to Canadian, Mexican and US Jurisdictions as appropriate. Codes for provinces (Canada) and states (US and Mexico). */
        get driverResidenceJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidenceJurisdictionCode');
        }
        /** Data element ID "DAP". Postal code of residence */
        get driverResidencePostalCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidencePostalCode');
        }
        /** Data element ID "DAL". Street address line 1 (mailing). */
        get driverResidenceStreetAddress1() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidenceStreetAddress1');
        }
        /** Data element ID "DAM". Street address line 2 (mailing). */
        get driverResidenceStreetAddress2() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidenceStreetAddress2');
        }
        /** Data element ID "DDE". A code that indicates whether a field has been truncated (T), has not been truncated (N), or – unknown whether truncated (U). */
        get familyNameTruncation() {
            return this.document.fields.find((f) => f.type.name === 'FamilyNameTruncation');
        }
        /** Data element ID "DCH". Federal Commercial Vehicle Codes */
        get federalCommercialVehicleCodes() {
            return this.document.fields.find((f) => f.type.name === 'FederalCommercialVehicleCodes');
        }
        /** Data element ID "DDF". A code that indicates whether a field has been truncated (T), has not been truncated (N), or – unknown whether truncated (U). */
        get firstNameTruncation() {
            return this.document.fields.find((f) => f.type.name === 'FirstNameTruncation');
        }
        /** Data element ID "DDC". Date on which the hazardous material endorsement granted by the document is no longer valid. The format is ISO8601 with delimiters. */
        get hazmatEndorsementExpirationDate() {
            return this.document.fields.find((f) => f.type.name === 'HAZMATEndorsementExpirationDate');
        }
        /** Data element ID "DAZ". Color of cardholder's hair. ANSI D-20 codes converted to human readable format according to the ANSI D20 Data Dictionary. */
        get hairColor() {
            return this.document.fields.find((f) => f.type.name === 'HairColor');
        }
        /** Data element ID "DAV". Height in centimeters */
        get height() {
            return this.document.fields.find((f) => f.type.name === 'Height');
        }
        /** Data element ID "DCK". A string of letters and/or numbers that is affixed to the raw materials (card stock, laminate, etc.) used in producing driver licenses and ID cards. (DHS recommended field). */
        get inventoryControlNumber() {
            return this.document.fields.find((f) => f.type.name === 'InventoryControlNumber');
        }
        /** Data element ID "DBE". A string used by some jurisdictions to validate the document against their data base. */
        get issueTimeStamp() {
            return this.document.fields.find((f) => f.type.name === 'IssueTimeStamp');
        }
        /** Data element ID "DCQ". Text that explains the jurisdiction-specific code(s) that indicates additional driving privileges granted to the cardholder beyond the vehicle class. */
        get jurisdictionSpecificEndorsementCodeDescription() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificEndorsementCodeDescription');
        }
        /** Data element ID "DCD". Jurisdiction-specific codes that represent additional privileges granted to the cardholder beyond the vehicle class (such as transportation of passengers, hazardous materials, operation of motorcycles, etc.). */
        get jurisdictionSpecificEndorsementCodes() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificEndorsementCodes');
        }
        /** Data element ID "DCR". Text describing the jurisdiction-specific restriction code(s) that curtail driving privileges. */
        get jurisdictionSpecificRestrictionCodeDescription() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificRestrictionCodeDescription');
        }
        /** Data element ID "DCB". Jurisdiction-specific codes that represent restrictions to driving privileges (such as airbrakes, automatic transmission, daylight only, etc.). */
        get jurisdictionSpecificRestrictionCodes() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificRestrictionCodes');
        }
        /** Data element ID "DCA". Jurisdiction-specific vehicle class / group code, designating the type of vehicle the cardholder has privilege to drive. */
        get jurisdictionSpecificVehicleClass() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificVehicleClass');
        }
        /** Data element ID "DCP". Text that explains the jurisdiction-specific code(s) for classifications of vehicles cardholder is authorized to drive. */
        get jurisdictionSpecificVehicleClassificationDescription() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificVehicleClassificationDescription');
        }
        /** Data element ID "DDD". DHS required field that indicates that the cardholder has temporary lawful status = "1". */
        get limitedDurationDocumentIndicator() {
            return this.document.fields.find((f) => f.type.name === 'LimitedDurationDocumentIndicator');
        }
        /** Data element ID "DDG". A code that indicates whether a field has been truncated (T), has not been truncated (N), or – unknown whether truncated (U). */
        get middleNameTruncation() {
            return this.document.fields.find((f) => f.type.name === 'MiddleNameTruncation');
        }
        /** Data element ID "DCU". Name Suffix (If jurisdiction participates in systems requiring name suffix (PDPS, CDLIS, etc.), the suffix must be collected and displayed on the DL/ID and in the MRT). Collect full name for record, print as many characters as possible on portrait side of DL/ID. JR (Junior), SR (Senior), 1ST or I (First), 2ND or II (Second),  3RD or III (Third),  4TH or IV (Fourth), 5TH or V (Fifth), 6TH or VI (Sixth), 7TH or VII (Seventh), 8TH or VIII (Eighth), 9TH or IX (Ninth). */
        get nameSuffix() {
            return this.document.fields.find((f) => f.type.name === 'NameSuffix');
        }
        /** Data element ID "DBI". "Y"; Used by some jurisdictions to indicate holder of the document is a non-resident. */
        get nonResidentIndicator() {
            return this.document.fields.find((f) => f.type.name === 'NonResidentIndicator');
        }
        /** Data element ID "DBF". Number of duplicate cards issued for a license or ID if any. */
        get numberOfDuplicates() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfDuplicates');
        }
        /** Data element ID "DBH". Organ Donor */
        get organDonor() {
            return this.document.fields.find((f) => f.type.name === 'OrganDonor');
        }
        /** Data element ID "DDK". Field that indicates that the cardholder is an organ donor = "1". */
        get organDonorIndicator() {
            return this.document.fields.find((f) => f.type.name === 'OrganDonorIndicator');
        }
        /** Data element ID "PAB". Date permit expires, The format is ISO8601 with delimiters. */
        get permitExpirationDate() {
            return this.document.fields.find((f) => f.type.name === 'PermitExpirationDate');
        }
        /** Data element ID "PAC". Type of permit. */
        get permitIdentifier() {
            return this.document.fields.find((f) => f.type.name === 'PermitIdentifier');
        }
        /** Data element ID "DAY". Color of cardholder's eyes. ANSI D-20 codes converted to human readable format according to the ANSI D20 Data Dictionary. */
        get physicalDescriptionEyeColor() {
            return this.document.fields.find((f) => f.type.name === 'PhysicalDescriptionEyeColor');
        }
        /** Data element ID "DAU". Height of cardholder. Inches (in): number of inches followed by " in" or Centimeters (cm): number of centimeters followed by " cm." */
        get physicalDescriptionHeight() {
            return this.document.fields.find((f) => f.type.name === 'PhysicalDescriptionHeight');
        }
        /** Data element ID "DBC". Gender of the cardholder. "Male" or "Female". */
        get physicalDescriptionSex() {
            return this.document.fields.find((f) => f.type.name === 'PhysicalDescriptionSex');
        }
        /** Data element ID "DCE". Indicates the approximate weight range of the cardholder: 0 = up to 31 kg (up to 70 lbs), 1 = 32 – 45 kg (71 – 100 lbs), 2 = 46 - 59 kg (101 – 130 lbs), 3 = 60 - 70 kg (131 – 160 lbs), 4 = 71 - 86 kg (161 – 190 lbs), 5 = 87 - 100 kg (191 – 220 lbs), 6 = 101 - 113 kg (221 – 250 lbs), 7 = 114 - 127 kg (251 – 280 lbs), 8 = 128 – 145 kg (281 – 320 lbs), 9 = 146+ kg (321+ lbs). */
        get physicalDescriptionWeightRange() {
            return this.document.fields.find((f) => f.type.name === 'PhysicalDescriptionWeightRange');
        }
        /** Data element ID "DCI". Country and municipality and/or state/province. */
        get placeOfBirth() {
            return this.document.fields.find((f) => f.type.name === 'PlaceOfBirth');
        }
        /** Data element ID "DCL". Codes for race or ethnicity of the cardholder. ANSI D-20 codes converted to human readable format according to the ANSI D20 Data Dictionary. */
        get raceEthnicity() {
            return this.document.fields.find((f) => f.type.name === 'RaceEthnicity');
        }
        /** Data element ID "DBK". The number assigned to an individual by the Social Security Administration. */
        get socialSecurityNumber() {
            return this.document.fields.find((f) => f.type.name === 'SocialSecurityNumber');
        }
        /** Data element ID "DCN". Standard endorsement code(s) for cardholder. See codes in D20. This data element is a placeholder for future efforts to standardize endorsement codes. */
        get standardEndorsementCode() {
            return this.document.fields.find((f) => f.type.name === 'StandardEndorsementCode');
        }
        /** Data element ID "DCO". Standard restriction code(s) for cardholder. See codes in D20. This data element is a placeholder for future efforts to standardize restriction codes. */
        get standardRestrictionCode() {
            return this.document.fields.find((f) => f.type.name === 'StandardRestrictionCode');
        }
        /** Data element ID "DCM". Standard vehicle classification code(s) for cardholder. This data element is a placeholder for future efforts to standardize vehicle classifications. */
        get standardVehicleClassification() {
            return this.document.fields.find((f) => f.type.name === 'StandardVehicleClassification');
        }
        /** Data element ID "DDH". Date on which the cardholder turns 18 years old. The format is ISO8601 with delimiters. */
        get under18Until() {
            return this.document.fields.find((f) => f.type.name === 'Under18Until');
        }
        /** Data element ID "DDI". Date on which the cardholder turns 19 years old. The format is ISO8601 with delimiters. */
        get under19Until() {
            return this.document.fields.find((f) => f.type.name === 'Under19Until');
        }
        /** Data element ID "DDJ". Date on which the cardholder turns 21 years old. The format is ISO8601 with delimiters. */
        get under21Until() {
            return this.document.fields.find((f) => f.type.name === 'Under21Until');
        }
        /** Data element ID "DBJ". A number or alphanumeric string used by some jurisdictions to identify a "customer" across multiple data bases. */
        get uniqueCustomerIdentifier() {
            return this.document.fields.find((f) => f.type.name === 'UniqueCustomerIdentifier');
        }
        /** Data element ID "DDL". Field that indicates that the cardholder is a veteran = "1". */
        get veteranIndicator() {
            return this.document.fields.find((f) => f.type.name === 'VeteranIndicator');
        }
        /** Data element ID "DAX". Cardholder weight in kilograms Ex. 84 kg = "084" */
        get weightKilograms() {
            return this.document.fields.find((f) => f.type.name === 'WeightKilograms');
        }
        /** Data element ID "DAW". Cardholder weight in pounds Ex. 185 lb = "185" */
        get weightPounds() {
            return this.document.fields.find((f) => f.type.name === 'WeightPounds');
        }
    }
    AAMVA.DLID = DLID;
    /** Driver License. File type "DL". */
    class DriverLicense extends DLID {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return AAMVADriverLicenseDocumentType;
        }
    }
    AAMVA.DriverLicense = DriverLicense;
    /** ID Card. File type "ID". */
    class IDCard extends DLID {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return AAMVAIDCardDocumentType;
        }
    }
    AAMVA.IDCard = IDCard;
    /** Enhanced Driver License. File type "EN". */
    class EnhancedDriverLicense extends DLID {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return AAMVAEnhancedDriverLicenseDocumentType;
        }
    }
    AAMVA.EnhancedDriverLicense = EnhancedDriverLicense;
    /** The raw document as was parsed from the barcode. The original field key names and field values as they appear in the barcode are left as-is. The mnemonic field keys from the AAMVA specification are not replaced with human-readable names. No field value normalization, like ISO 8601 date reformatting, etc., is done. */
    class RawDocument {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVARawDocumentDocumentType;
        }
    }
    AAMVA.RawDocument = RawDocument;
})(AAMVA || (AAMVA = {}));
/** HIBC */
export class HIBC {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return HIBCDocumentType;
    }
    /** Date of Manufacture */
    get dateOfManufacture() {
        return this.document.fields.find((f) => f.type.name === 'DateOfManufacture');
    }
    /** Expiry Date Day */
    get expiryDateDay() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateDay');
    }
    /** Expiry Date Hour */
    get expiryDateHour() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateHour');
    }
    /** Expiry Date Julian Day */
    get expiryDateJulianDay() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateJulianDay');
    }
    /** Expiry Date Month */
    get expiryDateMonth() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateMonth');
    }
    /** Expiry Date Year */
    get expiryDateYear() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateYear');
    }
    /** Information whether primary data is present. */
    get hasPrimaryData() {
        return this.document.fields.find((f) => f.type.name === 'HasPrimaryData');
    }
    /** Information whether secondary data is present. */
    get hasSecondaryData() {
        return this.document.fields.find((f) => f.type.name === 'HasSecondaryData');
    }
    /** Labeler Identification Code (LIC) */
    get labelerIdentificationCode() {
        return this.document.fields.find((f) => f.type.name === 'LabelerIdentificationCode');
    }
    /** Labelers Product or Catalog Number (PCN). Alphanumeric data. */
    get labelersProductOrCatalogNumber() {
        return this.document.fields.find((f) => f.type.name === 'LabelersProductOrCatalogNumber');
    }
    /** Link character to link standalone primary and secondary barcodes together. */
    get linkCharacter() {
        return this.document.fields.find((f) => f.type.name === 'LinkCharacter');
    }
    /** Lot Number */
    get lotNumber() {
        return this.document.fields.find((f) => f.type.name === 'LotNumber');
    }
    /** Quantity */
    get quantity() {
        return this.document.fields.find((f) => f.type.name === 'Quantity');
    }
    /** Serial Number */
    get serialNumber() {
        return this.document.fields.find((f) => f.type.name === 'SerialNumber');
    }
    /** Unit of Measure ID, Numeric value only, 0 through 9, where 0 always represents
  a single unit. 1 to 8 are used to indicate different packaging levels above the unit of use.
  The value 9 is used for variable quantity containers when manual key entry or scan of
  a secondary will be used to collect specific quantity data.
  The labeler should ensure consistency in this field within their packaging process.
   */
    get unitOfMeasureID() {
        return this.document.fields.find((f) => f.type.name === 'UnitOfMeasureID');
    }
}
//# sourceMappingURL=BarcodeDocumentModel.js.map